// Angular
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

// Partials
import { PartialsModule } from '../../partials/partials.module';
// Pages
import { CoreModule } from '../../../core/core.module';
// Security
import { AuthGuard } from '../../../core/auth/_guards/auth.guard';
import { PermissionType } from '../../../core/auth/enums/permission.enum';

import { MaterialModule } from '../material.module';
import { RouterModule } from '@angular/router';
import { EvaluationScorePageComponent } from './evaluation-score-page/evaluation-score-page.component';
import { LockDialogComponent } from './evaluation-score-page/dialogs/lock-dialog/lock-dialog.component';
import { AddtaskDialogComponent } from './evaluation-score-page/dialogs/addtask-dialog/addtask-dialog.component';
import { NotificationComponent } from './notification/notification.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StringFormatPipe } from '../../../core/_base/layout/pipes/string-format.pipe';
import { SpecialTaskDetailDialogComponent } from './evaluation-score-page/dialogs/special-task-detail-dialog/special-task-detail-dialog.component';
import { EvaluationFormItemModule } from '../../models/evaluation-form-item/evaluation-form-item.module';
import { TextInputModule } from '../../models/input/text-input/text-input.module';
import { SelectInputModule } from '../../models/input/select-input/select-input.module';
import { TracingPlanTaskComponent } from './tracing-plan-task/tracing-plan-task.component';
import { IterativeTaskComponent } from './iterative-task/iterative-task.component';
import { ConversationManagerModule } from '../../models/conversation-manager/conversation-manager.module';

@NgModule({
	declarations: [
		EvaluationScorePageComponent,
		LockDialogComponent,
		AddtaskDialogComponent,
		// NotificationComponent,
		SpecialTaskDetailDialogComponent,
		TracingPlanTaskComponent,
		IterativeTaskComponent,
	],
	exports: [
		MaterialModule,
		EvaluationScorePageComponent,
		TracingPlanTaskComponent,
		IterativeTaskComponent,
	],
	imports: [
		PartialsModule,
		CoreModule,
		CommonModule,
		MaterialModule,
		NgxSkeletonLoaderModule,
		EvaluationFormItemModule,
		TranslateModule.forChild(),
		TextInputModule,
		SelectInputModule,
		ConversationManagerModule,
	],
	providers: [
		StringFormatPipe,
		DecimalPipe,
	]
})
export class CommonPagesModule {
}